import { z } from "zod";

export const ThemeSchema = z.enum(["light", "dark"]);
export type Theme = z.infer<typeof ThemeSchema>;

const STORAGE_KEY = "og-orm-theme";

export function readStoredTheme(): Theme {
  const parsed = ThemeSchema.safeParse(localStorage.getItem(STORAGE_KEY));
  return parsed.success ? parsed.data : "dark";
}

export function applyTheme(theme: Theme): void {
  document.documentElement.dataset.theme = theme;
  localStorage.setItem(STORAGE_KEY, theme);
}

/** Apply persisted theme before React mounts (avoids flash). */
export function initTheme(): Theme {
  const theme = readStoredTheme();
  applyTheme(theme);
  return theme;
}
